import * as React from 'react';
import { ReactElement } from 'react';

export default function Unrefinable(): ReactElement {
    return <div className="text-info">Nothing to filter on</div>;
}
